import LockCard from '../../../../banking/components/cards/LockCard';

const LockCardScreen = () => {
    return <LockCard />;
};

export default LockCardScreen;
